import React from "react";
import GamStandard from "./gam_standard";
import KevelStandard from "./kevel_standard";

const Standard = (props) => {
  const templates = {
    gam: GamStandard,
    kevel: KevelStandard,
  };

  const TemplateComponent = templates[props.service];
  const renderTemplate = <TemplateComponent {...props} />;
  return <>{renderTemplate}</>;
};

export default Standard;
